document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('div[id*=ticksell_ticksell_container]');
  const insertAfterElement = document.querySelector('#teeFormActions');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.before(elementToMove)
  } 

  window.teeinblue.transformBeforeAddToCart = (input) => {
    let output = input;

    if (typeof originalTransform === 'function') {
      output = originalTransform(input);
    }

    const checkedUpsell = document.querySelector('#ticksell-container input[type="checkbox"]:checked');
    if (checkedUpsell) {
      const upsellGroup = checkedUpsell.closest('.ticksell-group');
      if (upsellGroup) {
        const id = upsellGroup.getAttribute('data-variant-id');
        const quantity = 1;
        if (id) {
          if (Array.isArray(output)) {
            output.push({ id, quantity });
          } else {
            output = [output, { id, quantity }];
          }
        }
      }
    }

    return output;
  };
});

document.addEventListener('teeinblue-event-component-injected', () => {
  moveElementAfter('.tee-block.tee-product-price', '.rating-stars');
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};

(() => {
  if (window.__teeCartThumbnailPreviewBound) return;
  window.__teeCartThumbnailPreviewBound = true;

  function waitForElementInRoot(root, selector, timeout = 3000) {
    return new Promise((resolve, reject) => {
      if (!root) {
        reject(new Error('Root element not found'));
        return;
      }

      const found = root.querySelector(selector);
      if (found) {
        resolve(found);
        return;
      }

      const observer = new MutationObserver(() => {
        const el = root.querySelector(selector);
        if (el) {
          observer.disconnect();
          clearTimeout(timer);
          resolve(el);
        }
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });

      const timer = setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element not found: ${selector}`));
      }, timeout);
    });
  }

  async function handleThumbnailClick(event) {
    const img = event.target.closest('img.tee-cart-thumbnail__img');
    console.log(event.target, img)
    if (!img) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const cartItem = img.closest('.cart-item');
    if (!cartItem) return;

    try {
      const previewButton = await waitForElementInRoot(
        cartItem,
        'button.tee-preview-button',
        3000
      );

      previewButton.click();
    } catch (error) {
      console.warn('[tee-cart-thumbnail] Preview button not found', error);
    }
  }

  document.addEventListener('click', handleThumbnailClick, true);
})();
